export default "__VITE_ASSET__BmEkm7qN__"